import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { SwatchesPicker } from "react-color";

import { useState, useEffect } from "react";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";

import "styles/css/FeatureEditPopup.scss";

const ColorPickerPopup = new Popup({
	title: function() {
		return `${getLocaleString("colorpicker")}`;
	},
	style: {maxWidth: 550},
	render: function() {
		const [hex, setHex] = useState<string>(this.get('color'));
		
		const onSave:Function = this.get('onSave');
		
		return (
			<>
				<div style={{width: '100%'}}>
					<SwatchesPicker
						color={hex}
						onChange={ (color:any) => {
							setHex(color.hex);
							onSave(color.hex);
							_ui.closePopupOf(this);
						} }
					/>
				</div>
			</>
		)
	}
});

export default ColorPickerPopup;